import { SelectItem } from 'primeng/api';
import { criticalityOptions } from '../app/shared/constants/criticality-option.constans';
import { stageOptions } from '../app/shared/constants/stage-options.constant';

export function getEnumLabel<T extends string | number | boolean>(
  value: T | undefined,
  options: SelectItem<T>[],
): string | number | boolean {
  if (value === undefined) return '';
  const opt = options.find((o) => o.value === value);
  return opt?.label ?? value;
}

export function getStageLabel(
  value: number | undefined,
  options = stageOptions,
) {
  return getEnumLabel(value, options);
}

export function getCriticalityLabel(
  value: string | undefined,
  options = criticalityOptions,
) {
  return getEnumLabel(value, options);
}